import { Component, inject, OnInit, signal } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
    selector: 'core-block-user-aa-table',
    templateUrl: './block-user-aa-table.component.html',
    styleUrl: './block-user-aa-table.component.scss',
    standalone: false,
})
export class BlockUserAaTableComponent extends BlockAbstractComponent implements OnInit {
    private readonly http = inject(HttpClient);

    isMocked = signal(false);

    private mockData = [
        {
            collectionId: 999,
            dateCreated: 1735689600,
            dateModified: 1735689600,
            id: 999,
            identifiers: { YEAR: '2025' },
            content: [
                {
                    DC_INPUT: '372.37',
                    DB_INPUT: '0.00',
                    PENSION_CONTS: '434.44',
                    EST_ADJUST_INCOME: '0.00',
                    EST_THRESHOLD_INCOME: '8454.65',
                    TAA: '60000.00',
                    TAXABLE_VALUE: '0.00',
                    DB_DC_INPUT: '372.37',
                    CARRY_FORWARD: '119048.12',
                    Y16_EXE_EXCL: '1',
                    Y16_EXE_INCL: '1',
                    START_DATE_PRE_2014: '1',
                    YEAR: '2025',
                },
            ],
        },
    ];

    data = signal<any>(undefined);

    override ngOnInit() {
        const collectionTypeId = this.block.data.chosenCollection;
        if (this.isMocked() || collectionTypeId) {
            this.loadData(collectionTypeId);
        }
    }

    private loadData(collectionTypeId: number): void {
        const data$ = this.isMocked()
            ? new Observable(subscriber => {
                  subscriber.next(this.mockData);
                  subscriber.complete();
              })
            : this.getUserCollections(collectionTypeId, null, true);

        data$.subscribe(data => {
            this.data.set(data);
        });
    }

    private getUserCollections(typeId: number, identifiers?: unknown | null, includeContent?: boolean) {
        let params = new HttpParams().set('content', includeContent ? 'true' : 'false');
        if (identifiers !== null && identifiers !== undefined) {
            params = params.set('identifiers', JSON.stringify(identifiers || {}));
        }
        params = params.set('interact', 'false').set('typeId', typeId);
        return this.http.get('user-collections', { params });
    }

    protected getColumnData(dataHeader: any) {
        return this.data()?.[0].content[0][dataHeader];
    }
}
